import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { defaultMemoize } from 'reselect';
import _get from 'lodash/get';
import _isNil from 'lodash/isNil';
import _size from 'lodash/size';
import _noop from 'lodash/noop';
import _isEqual from 'lodash/isEqual';
import _identity from 'lodash/identity';
import _isFunction from 'lodash/isFunction';
import _includes from 'lodash/includes';

// Constants
import { EMPTY_OBJECT, EMPTY_ARRAY } from '@tekion/tekion-base/app.constants';
import FORM_ACTION_TYPES from '../../../FormBuilder/constants/actionTypes';
import { triggerFocusPrev, triggerFocusNext } from '../../../../pages/formPage/utils/formAction';
import KEY_CODES from './constants/withTableShortcutKeys.keyCodes';

// Helpers
import { getRefListAndColumns, findParent, isLastRowNotEmpty, getNextFocusableFieldOnEnter, getDefaultColumnIdIndex, getInput } from './withTableShortcutKeys.helpers';
var withShortcutKeys = function withShortcutKeys(WrappedComponent) {
  var WithShortcutKeys = /*#__PURE__*/function (_Component) {
    _inherits(WithShortcutKeys, _Component);
    var _super = _createSuper(WithShortcutKeys);
    function WithShortcutKeys(props) {
      var _this;
      _classCallCheck(this, WithShortcutKeys);
      _this = _super.call(this, props);
      _defineProperty(_assertThisInitialized(_this), "getDefaultColumnIdIndex", defaultMemoize(getDefaultColumnIdIndex));
      _defineProperty(_assertThisInitialized(_this), "setRowAndColumn", function (e) {
        var element = e.target;
        var _this$getIndex = _this.getIndex(element),
          row = _this$getIndex.row,
          column = _this$getIndex.column;
        _this.currentRow = row;
        _this.currentColumn = column;
      });
      _defineProperty(_assertThisInitialized(_this), "getIndex", function (element) {
        var cell = findParent(element, 'focusable');
        if (cell) {
          var className = cell.className.split('-indexed-')[1];
          var indexes = className.split('.');
          return {
            row: Number(indexes[0]),
            column: Number(indexes[1])
          };
        }
        return EMPTY_OBJECT;
      });
      _defineProperty(_assertThisInitialized(_this), "handleTabEvent", function (e, row, column) {
        var columns = _this.props.columns;
        var lastColumnIndex = _size(columns) - 1;
        var parent = _this.tableComponent.current;
        if (column < lastColumnIndex) {
          return {
            row: row,
            column: column + 1
          };
        }
        var columnIndex;
        for (columnIndex = 0; columnIndex <= lastColumnIndex; columnIndex += 1) {
          var input = getInput(row + 1, columnIndex, parent);
          if (input) {
            break;
          }
        }
        return {
          row: row + 1,
          column: columnIndex
        };
      });
      _defineProperty(_assertThisInitialized(_this), "handleEnterEvent", function (e, row, column) {
        var _this$props = _this.props,
          tableShortCutProps = _this$props.tableShortCutProps,
          columns = _this$props.columns,
          value = _this$props.value;
        var moveToEmptyFieldOnEnter = tableShortCutProps.moveToEmptyFieldOnEnter,
          defaultColumnIdForEnter = tableShortCutProps.defaultColumnIdForEnter;
        if (!moveToEmptyFieldOnEnter) {
          return {
            row: row,
            column: column + 1
          };
        }
        var parent = _this.tableComponent.current;
        var defaultColumnIdIndex = _this.getDefaultColumnIdIndex(columns, defaultColumnIdForEnter);
        var _getNextFocusableFiel = getNextFocusableFieldOnEnter({
            defaultColumnIdIndex: defaultColumnIdIndex,
            currentColumn: column,
            currentRow: row,
            value: value,
            columns: columns,
            parent: parent
          }),
          rowIndexToFocus = _getNextFocusableFiel.row,
          columnIndexToFocus = _getNextFocusableFiel.column;
        return {
          row: rowIndexToFocus,
          column: columnIndexToFocus
        };
      });
      _defineProperty(_assertThisInitialized(_this), "keyBoardHandler", function (e) {
        e.stopPropagation();
        e.preventDefault();
        var _this$props2 = _this.props,
          value = _this$props2.value,
          columns = _this$props2.columns,
          _this$props2$tableSho = _this$props2.tableShortCutProps,
          tableShortCutProps = _this$props2$tableSho === void 0 ? EMPTY_OBJECT : _this$props2$tableSho;
        var _tableShortCutProps$s = tableShortCutProps.skipList,
          skipList = _tableShortCutProps$s === void 0 ? EMPTY_OBJECT : _tableShortCutProps$s,
          _tableShortCutProps$a = tableShortCutProps.alwaysHandlePeriodFor,
          alwaysHandlePeriodFor = _tableShortCutProps$a === void 0 ? EMPTY_ARRAY : _tableShortCutProps$a,
          handleEscape = tableShortCutProps.handleEscape;
        var _assertThisInitialize = _assertThisInitialized(_this),
          currentRow = _assertThisInitialize.currentRow,
          currentColum = _assertThisInitialize.currentColumn;
        var column = currentColum;
        var isNext = true;
        var row = currentRow;
        _this.isInputKey = false;
        var currentColumn = columns[column] || EMPTY_OBJECT;
        var columnKeySkipList = skipList[currentColumn.id] || EMPTY_ARRAY;
        var currentValue = _get(value, "".concat(row, ".").concat(currentColumn.id));
        var valueGetter = currentColumn.getValueForKeyboardShortcuts || _identity;
        var valueToCompare = valueGetter(currentValue);
        var keyCode = e.code;
        if (columnKeySkipList.includes(keyCode)) {
          return;
        }
        if (e.shiftKey) {
          if (keyCode === KEY_CODES.TAB) {
            column -= 1;
          } else {
            return;
          }
        } else {
          switch (keyCode) {
            case KEY_CODES.TAB:
              {
                var _this$handleTabEvent = _this.handleTabEvent(e, row, column),
                  focusableRow = _this$handleTabEvent.row,
                  focusableColumn = _this$handleTabEvent.column;
                row = focusableRow;
                column = focusableColumn;
                break;
              }
            case KEY_CODES.ARROW_RIGHT:
              column += 1;
              break;
            case KEY_CODES.NUMPAD_ENTER:
            case KEY_CODES.ENTER:
              {
                var _this$handleEnterEven = _this.handleEnterEvent(e, row, column),
                  _focusableRow = _this$handleEnterEven.row,
                  _focusableColumn = _this$handleEnterEven.column;
                row = _focusableRow;
                column = _focusableColumn;
                break;
              }
            case KEY_CODES.SPACE:
              _this.handleSpaceEvent(e, row, column);
              break;
            case KEY_CODES.ARROW_LEFT:
              column -= 1;
              isNext = false;
              break;
            case KEY_CODES.ARROW_DOWN:
              row += 1;
              break;
            case KEY_CODES.ARROW_UP:
              row -= 1;
              isNext = false;
              break;
            case KEY_CODES.NUMPAD_DECIMAL:
            case KEY_CODES.PERIOD:
              _this.isInputKey = true;
              if (_isNil(valueToCompare) || valueToCompare === '.' || alwaysHandlePeriodFor.includes(currentColumn.id)) {
                _this.setElementValue(row, column, isNext, keyCode);
              }
              break;
            case KEY_CODES.ESCAPE:
              if (_isFunction(handleEscape)) {
                handleEscape();
              }
              break;
            default:
              _this.isInputKey = true;
              break;
          }
        }
        _this.handleFocus(row, column, isNext, keyCode);
      });
      _defineProperty(_assertThisInitialized(_this), "handleFocusForLastColumn", function (row, value, isNext, keyCode, tableShortCutProps, className) {
        var isLastRow = row === _size(value) - 1;
        if (isLastRow) {
          var isNonEmptyLastRow = isLastRowNotEmpty(value, tableShortCutProps);
          if (isNonEmptyLastRow) {
            _this.focusElement(row + 1, 0, isNext, keyCode);
          } else {
            triggerFocusNext(className);
          }
        } else {
          _this.focusElement(row + 1, 0, isNext, keyCode);
        }
      });
      _defineProperty(_assertThisInitialized(_this), "handleFocus", function (row, column, isNext, keyCode) {
        var _this$props3 = _this.props,
          value = _this$props3.value,
          columns = _this$props3.columns,
          tableShortCutProps = _this$props3.tableShortCutProps,
          className = _this$props3.className;
        var valueSize = _size(value);
        if (column >= 0 && row >= 0 && row < valueSize && column <= columns.length - 1 || row === valueSize) {
          _this.focusElement(row, column, isNext, keyCode);
        } else if (column === columns.length) {
          _this.handleFocusForLastColumn(row, value, isNext, keyCode, tableShortCutProps, className);
        } else if (column === -1 && row !== 0) {
          _this.focusElement(row - 1, columns.length - 1, isNext, keyCode);
        } else if (column === -1) {
          if (isNext === undefined) {
            _this.focusElement(row, column + 1, true, keyCode);
          } else {
            triggerFocusPrev(className);
          }
        }
      });
      _defineProperty(_assertThisInitialized(_this), "handleAddNewRow", function () {
        var _this$props4 = _this.props,
          value = _this$props4.value,
          onAction = _this$props4.onAction,
          _this$props4$tableSho = _this$props4.tableShortCutProps,
          tableShortCutProps = _this$props4$tableSho === void 0 ? EMPTY_OBJECT : _this$props4$tableSho;
        var addNewRowActionType = tableShortCutProps.addNewRowActionType;
        if (addNewRowActionType) {
          onAction({
            type: addNewRowActionType,
            payload: {
              value: value
            }
          });
        }
      });
      _defineProperty(_assertThisInitialized(_this), "handleSpaceEvent", function (event, row, column) {
        var element = event.target;
        var cell = findParent(element, 'focusable');
        if (cell && cell instanceof Node) {
          var checkbox = cell.querySelector('input[type="checkbox"]');
          if (event.code === KEY_CODES.SPACE && checkbox) {
            var _this$props5 = _this.props,
              value = _this$props5.value,
              columns = _this$props5.columns,
              onAction = _this$props5.onAction;
            var columnId = _get(columns, "".concat(column, ".id"));
            onAction({
              type: FORM_ACTION_TYPES.ON_FIELD_CHANGE,
              payload: {
                columnId: columnId,
                additional: {
                  pathToUpdate: row,
                  updatedValue: _objectSpread(_objectSpread({}, value[row]), {}, _defineProperty({}, columnId, !value[row][columnId]))
                },
                nestingPath: [row]
              }
            });
          }
        }
      });
      _defineProperty(_assertThisInitialized(_this), "setElementValue", function (row, column, isNext, keyCode) {
        var _this$props6 = _this.props,
          value = _this$props6.value,
          columns = _this$props6.columns,
          onAction = _this$props6.onAction;
        var columnId = _get(columns, "".concat(column, ".id"));
        var getValueOnPeriodPress = _get(columns, "".concat(column, ".getValueOnPeriodPress"), _identity);
        var valueOfAboveRow = _get(value, "".concat(row - 1, ".").concat(columnId));
        var newValue = getValueOnPeriodPress(valueOfAboveRow);
        if (value[row - 1]) {
          onAction({
            type: FORM_ACTION_TYPES.ON_FIELD_CHANGE,
            payload: {
              columnId: columnId,
              additional: {
                pathToUpdate: row,
                updatedValue: _objectSpread(_objectSpread({}, value[row]), {}, _defineProperty({}, columnId, newValue))
              },
              nestingPath: [row]
            }
          });
          _this.focusElement(row, column + 1, isNext, keyCode);
        }
      });
      _defineProperty(_assertThisInitialized(_this), "getRowAndColumnToFocus", function (row, column, isNext, keyCode) {
        var focusRow = row;
        var focusColumn = column;
        switch (keyCode) {
          case KEY_CODES.ARROW_DOWN:
            focusRow += 1;
            break;
          case KEY_CODES.ARROW_UP:
            focusRow -= 1;
            break;
          case KEY_CODES.NUMPAD_ENTER:
          case KEY_CODES.ENTER:
            {
              var _this$handleEnterEven2 = _this.handleEnterEvent(undefined, row, column),
                focusableRow = _this$handleEnterEven2.row,
                focusableColumn = _this$handleEnterEven2.column;
              focusRow = focusableRow;
              focusColumn = focusableColumn;
              break;
            }
          default:
            focusColumn = isNext ? column + 1 : column - 1;
            break;
        }
        return {
          focusRow: focusRow,
          focusColumn: focusColumn
        };
      });
      _defineProperty(_assertThisInitialized(_this), "focusElement", function (row, column, isNext, keyCode) {
        var _this$props7 = _this.props,
          value = _this$props7.value,
          _this$props7$tableSho = _this$props7.tableShortCutProps,
          tableShortCutProps = _this$props7$tableSho === void 0 ? EMPTY_OBJECT : _this$props7$tableSho;
        if (row >= _size(value)) {
          var isNonEmptyLastRow = isLastRowNotEmpty(value, tableShortCutProps);
          if (isNonEmptyLastRow) {
            _this.handleAddNewRow();
          }
        }
        var parent = _this.tableComponent.current || document;
        var cell = parent.getElementsByClassName("focusClass-indexed-".concat(row, ".").concat(column, "-indexed-"))[0];
        if (cell && cell instanceof Node) {
          var disabled = cell.classList.contains('focus-disabled');
          if (disabled) {
            var _this$getRowAndColumn = _this.getRowAndColumnToFocus(row, column, isNext, keyCode),
              focusRow = _this$getRowAndColumn.focusRow,
              focusColumn = _this$getRowAndColumn.focusColumn;
            _this.handleFocus(focusRow, focusColumn, isNext, keyCode);
            return;
          }
          var input = cell.querySelector('input');
          if (input) {
            var _columnList$column;
            input.focus();
            var valueLength = _get(input, 'value.length');
            if (!_this.isInputKey && valueLength) {
              input.selectionEnd = valueLength;
              input.selectionStart = valueLength;
            }
            var keyCodesVsEnabledColumnsToSelectText = tableShortCutProps.keyCodesVsEnabledColumnsToSelectText;
            var columnList = _this.state.columnList;
            var shouldSelectText = _includes(keyCodesVsEnabledColumnsToSelectText === null || keyCodesVsEnabledColumnsToSelectText === void 0 ? void 0 : keyCodesVsEnabledColumnsToSelectText[keyCode], columnList === null || columnList === void 0 ? void 0 : (_columnList$column = columnList[column]) === null || _columnList$column === void 0 ? void 0 : _columnList$column.id);
            if (shouldSelectText) {
              input.selectionEnd = valueLength;
              input.selectionStart = 0;
            }
          }
        }
        var _this$getIndex2 = _this.getIndex(document.activeElement),
          currentRow = _this$getIndex2.row,
          currentColum = _this$getIndex2.column;
        _this.currentRow = currentRow;
        _this.currentColumn = currentColum;
      });
      var _columnList = getRefListAndColumns(props);
      _this.tableComponent = /*#__PURE__*/React.createRef();
      _this.currentRow = 0;
      _this.currentColumn = 0;
      _this.isInputKey = false;
      _this.state = {
        columnList: _columnList
      };
      return _this;
    }
    _createClass(WithShortcutKeys, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        this.tableComponent.current.addEventListener('keydown', this.setRowAndColumn);
        this.tableComponent.current.addEventListener('keyup', this.keyBoardHandler);
      }
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        // eslint-disable-next-line react/destructuring-assignment
        if (!_isEqual(prevProps.columns, this.props.columns)) {
          var columnList = getRefListAndColumns(this.props);
          // eslint-disable-next-line react/no-did-update-set-state
          this.setState({
            columnList: columnList
          });
        }
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        this.tableComponent.current.removeEventListener('keydown', this.setRowAndColumn);
        this.tableComponent.current.removeEventListener('keyup', this.keyBoardHandler);
      }
    }, {
      key: "render",
      value: function render() {
        var columnList = this.state.columnList;
        var className = this.props.className;
        return /*#__PURE__*/React.createElement("div", {
          ref: this.tableComponent,
          className: className
        }, /*#__PURE__*/React.createElement(WrappedComponent, _extends({}, this.props, {
          columns: columnList
        })));
      }
    }]);
    return WithShortcutKeys;
  }(Component);
  WithShortcutKeys.propTypes = {
    columns: PropTypes.array,
    value: PropTypes.array,
    onAction: PropTypes.func,
    accountsMap: PropTypes.object,
    tableShortCutProps: PropTypes.object,
    className: PropTypes.string
  };
  WithShortcutKeys.defaultProps = {
    columns: EMPTY_ARRAY,
    value: EMPTY_ARRAY,
    onAction: _noop,
    accountsMap: EMPTY_OBJECT,
    tableShortCutProps: EMPTY_OBJECT,
    className: ''
  };
  return WithShortcutKeys;
};
export default withShortcutKeys;